import { SeriesRecord } from '@/components/Chart/types/chartData';

import { TimeSeriesPoint, TimeSeriesPointCustom } from './buildChartLineSeries';

/**
 * Transforms raw series data into a time series point for forward curve charts
 * @param tsData - Raw time series data array
 * @param decimalPlaces - Number of decimal places for formatting
 * @returns Formatted time series point with x, y coordinates and custom metadata
 */
export const takeForwardCurveData = (
  tsData: SeriesRecord,
  decimalPlaces: number
): TimeSeriesPoint => {
  const x = Number(tsData[3]);
  const y = Number(tsData[1]);
  const custom: TimeSeriesPointCustom = {
    transactionDate: tsData[0],
    periodAbs: tsData.length > 2 && tsData[2] ? tsData[2] : '',
    decimalPlaces
  };
  return { x, y, custom };
};
